var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.144,
    height: 64.393,
    viewBox: "0 0 60.144 64.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3fd4a2;}.b{fill:#d9f7ed;}.c{fill:#91ffda;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.535 -199.854) rotate(42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(191.864 119.739)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M198.625,188.809c-12.269,6.181-4.092,18.281-4.092,18.281a8.247,8.247,0,0,1,7-6.016l1.174-8.211Z",
    transform: "translate(-191.864 -188.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M278.6,188.809c12.269,6.181,4.092,18.281,4.092,18.281a8.247,8.247,0,0,0-7-6.016l-1.174-8.211Z",
    transform: "translate(-247.938 -188.809)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 18.087,
    height: 3.052,
    rx: 1.526,
    transform: "translate(201.535 134.968)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.576 138.02)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M225.925,259.4c-6.922-6.923-2.418-13.736-2.418-13.736h15.124c5.609,8.285-2.045,14.3-2.045,14.3.677-4.16-1.177-6.231-1.177-6.231a14.83,14.83,0,0,1-3.816,11.229c-4.579-4.252-4.579-11.011-4.579-11.011A6.792,6.792,0,0,0,225.925,259.4Z",
    transform: "translate(-222.067 -245.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M231.84,245.66a6.571,6.571,0,0,0-.327,6,8.321,8.321,0,0,1,1.853-2.944,13.851,13.851,0,0,0,4.034,8.83c2.78-2.562,3.761-7.794,3.761-7.794a11.525,11.525,0,0,1,2.181,3.652c1.09-2.889.76-5.669-1.145-7.74Z",
    transform: "translate(-228.09 -245.66)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M240.7,100.224A50.546,50.546,0,0,0,232.1,87l-.041.249V87a50.657,50.657,0,0,0-8.5,13.016A26.629,26.629,0,0,0,240.7,100.224Z",
    transform: "translate(-21.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M239.766,129.7q-.378-1-.819-2.011a26.629,26.629,0,0,1-17.14-.208q-.447,1.008-.828,2A28.8,28.8,0,0,0,239.766,129.7Z",
    transform: "translate(-19.753 -27.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M215.232,133.7a40.183,40.183,0,0,0,1.722,32.95h15.259a40.177,40.177,0,0,0,1.806-32.733A28.8,28.8,0,0,1,215.232,133.7Zm9.712,16.085a5.757,5.757,0,1,1,5.756-5.756A5.757,5.757,0,0,1,224.945,149.786Z",
    transform: "translate(-14.006 -31.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M239.037,147.92a5.757,5.757,0,1,0,5.756,5.757A5.757,5.757,0,0,0,239.037,147.92Zm0,9.827a4.071,4.071,0,1,1,4.07-4.07A4.07,4.07,0,0,1,239.037,157.747Z",
    transform: "translate(-28.098 -41.33)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/Rocket.41f2a10b91dcb973e295cd32821c5602.svg";
export { ForwardRef as ReactComponent };